var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#878787",
    fillRule: "evenodd",
    d: "M12 22.5C6.201 22.5 1.5 17.798 1.5 12S6.201 1.5 12 1.5 22.5 6.202 22.5 12 17.799 22.5 12 22.5zM12 0C5.372 0 0 5.37 0 12s5.372 12 12 12 12-5.37 12-12S18.628 0 12 0zm4.5 11.25h-3.75V7.5a.75.75 0 0 0-1.5 0v3.75H7.5a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0v-3.75h3.75a.75.75 0 0 0 0-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadMore);
export default __webpack_public_path__ + "static/media/load-more.a9d4c112.svg";
export { ForwardRef as ReactComponent };